import React from "react";



const LatestBinanceNews = () => {
const newsItems = [
  {
    title: 'Plasma USDT Locked Product: Total Subscription Limit Expands to 1B USDT With a New 250M USDT Quota',
    date: '2025-08-22',
  },
  {
    title: 'Participate in the Hemi (HEMI) Exclusive Pre-Token Generation Event (Pre-TGE) and Booster Program on Tillionx Wallet',
    date: '2025-08-22',
  },
  {
    title: "Introducing Plasma USDT Locked Product on Tillionx Earn's On-Chain Yields",
    date: '2025-08-20',
  },
  {
    title: 'Updates on Tick Size for Multiple USDⓈ-M Perpetual Futures Contracts (2025-08-25)',
    date: '2025-08-20',
  },
  {
    title: "Tillionx Earn Yield Arena: Enjoy Up to 20% APR With This Week's New Limited-Time Offers! (2025-08-20)",
    date: '2025-08-20',
  },
  {
    title: 'Tillionx VIP Launches Institutional Switch Package for High-Volume Traders',
    date: '2025-08-19',
  },
  {
    title: 'BFUSD Will No Longer Support the Subscription and Redemption of USDC',
    date: '2025-08-19',
  },
];
  return (
  <div className="rounded-lg shadow-sm p-6 border border-gray-200 max-w-7xl mx-auto font-sans my-16">
     <nav className="flex items-center text-sm  mb-6">
         
          <span className="">Announcement</span>
          <span className="mx-2">›</span>
          <span className="font-semibold text-xs">Latest Tillionx News</span>
        </nav>
      {/* Header */}
      <h2 className="text-xl font-bold mb-6">Latest Tillionx News</h2>

      {/* News List */}
      {newsItems.map((item, index) => (
        <div key={index} className="py-4 border-b border-gray-200 last:border-b-0">
          <h3 className="text-base font-medium leading-snug hover:underline cursor-pointer">
            {item.title}
          </h3>
          <p className="text-sm mt-1">{item.date}</p>
        </div>
      ))}
    </div>
  );
};

export default LatestBinanceNews;
